export default __webpack_public_path__ + "static/media/004-cutlery.e30d44b3.svg";